import { permissionGuard } from '../guards/permission.guard';

export const canUploadPromoPlanGuard = permissionGuard(
  'Promo Plan', // NOTE: Assumes 'Promo Plan' is the resource name in your backend.
  'upload',
  'You are not authorized to upload promo plans.'
);
